const storeInsights = {
  Active: "Active",
  AddAPatient: "Add a {{patientTerm}}",
  AdherenceForms: "Adherence surveys",
  AdherenceFormScheduling: "Adherence survey scheduling",
  AdherenceFormWillBeSentDate: "Adherence survey will be sent on {{date}}",
  AdherenceSchedulingWhatsNewModalPage1Body:
    "Add adherence survey scheduling to your {{treatmentPlanTerm}} experience. You can send adherence surveys to {{patientTermPlural}} and get feedback on your {{treatmentPlanTermPlural}}. Help {{patientTermPlural}} between visits in Fullscript.",
  AdherenceSchedulingWhatsNewModalPage1Title: "New: adherence survey scheduling",
  AZ: "A-Z",
  CaretDownAria: "Compared to 90 days ago, {{metric}} is down",
  CaretUpAria: "Compared to 90 days ago, {{metric}} is up",
  ClickADataTile:
    "Click a data tile below to view {{patientTerm}} engagement with your {{treatmentPlanTermPlural}} from the last {{dateRange}} days. All changes in figures shown are compared to a <8>90 day rolling average.<8>",
  ClickToLoadData: "Click chart to load data",
  Customize: "Customize",
  DataLastUpdated: "Last updated at {{timeAndDate}}",
  DecideSendPatientFeedback:
    "Decide if you would like to send {{patientTermPlural}} a survey where they can provide feedback on their {{treatmentPlanTerm}}. You will be able to view {{patientTerm}} feedback in Fullscript.",
  EntireDispensary: "Entire dispensary",
  ExpectedReorders: "Missed reorders",
  ExpectedReordersDescription:
    "This number is the % of {{patientTermPlural}} who should have already placed a follow up order for their {{treatmentPlanTerm}} in the last {{dateRange}} days. Fullscript calculates this number by using the dosage information in the {{treatmentPlanTermPlural}} you wrote for a specific {{patientTerm}}.",
  FeedbackFormSent: "Feedback survey sent",
  FeedbackIn7Days:
    "{{- patientName}} will be asked for feedback <3>7 days from today</3> if they do not order from this {{treatmentPlanTerm}}.",
  FirstThingToKnow: "Only active plans will be displayed by default.",
  FollowUp: "Follow up",
  FollowUpWithPatientsTitle: "Following up between appointments has never been easier.",
  FreeFromFS: "Free from Fullscript!",
  EmptyStateTextNoRxs: {
    title: "Send {{treatmentPlanTermPlural}} to your {{patientTermPlural}}",
    body: "Once you send a {{treatmentPlanTerm}}, insights on {{patientTerm}} ordering behaviours will appear here — making it easier to help keep your {{patientTermPlural}} on track.",
  },
  GetPatientFeedback: "Get {{patientTerm}} feedback in Fullscript",
  GetStartedwithTreatmentPlans: "Get started with {{treatmentPlanTermPlural}}",
  GoodThingsToKnow: "Good things to know:",
  Insights: "Insights",
  IndividualPlans: "Individual plans",
  KeepEyeOnPatientsDescription:
    "Fullscript insights lets you track your {{patientTermPlural}}' progress every step of the way. You can now easily see where a {{patientTerm}} is with their {{treatmentPlanTerm}} and reach out to help them get started with Fullscript.",
  KeepEyeOnPatientsTitle: "Keep an eye on your {{patientTermPlural}}.",
  Last14Days: "Last 14 days",
  Last30Days: "Last 30 days",
  Last7Days: "Last 7 days",
  LastCreatedNew: "Date created: newest",
  LastCreatedOld: "Date created: oldest",
  LearnMore: "Learn more",
  MonitorStatusOfTreatmentPlan:
    "You can monitor the status of their {{treatmentPlanTerm}} from the <3>insights page</3>.",

  MyPlans: "My plans",
  NeverSignedIn: "Never signed in",
  NoData: "No data available",
  NoDataAvailable: "No data available at this time.",
  NoOrder: "Not ordered",
  NoRxEmptyStateBlurb1:
    "Use Fullscript to track {{patientTerm}} order behavior and quickly reconnect with them between visits to help them stay on track. You'll see which {{patientTermPlural}} have created their Fullscript accounts, who is interacting with your {{treatmentPlanTermPlural}}, and which {{treatmentPlanTermPastParticiple}} products have been ordered and reordered.",
  NoRxEmptyStateBlurb2:
    "It's a great way to track {{patientTerm}} progress and help you have more informed conversations with your {{patientTermPlural}} to identify possible barriers to adherence and help them stay on track.",
  NotifyPatient: "Notify {{patientTerm}}",
  NotInterested: "Not Interested?",
  Ordered: "Ordered",
  PatientSaidOn: "{{patientName}} said on {{date}}: ",
  PercentOrdered_plural:
    "{{percent}}% ({{count}} {{treatmentPlanTermPlural}}) of your dispensary's {{treatmentPlanTermPlural}} have orders",
  PercentOrdered:
    "{{percent}}% ({{count}} {{treatmentPlanTerm}}) of your dispensary's {{treatmentPlanTermPlural}} have orders",
  PercentUnOrdered_plural:
    "{{percent}}% ({{count}} {{treatmentPlanTermPlural}}) of your dispensary's {{treatmentPlanTermPlural}} have no orders",
  PercentUnOrdered:
    "{{percent}}% ({{count}} {{treatmentPlanTerm}}) of your dispensary's {{treatmentPlanTermPlural}} have no orders",
  PrescriptionMetrics: "{{treatmentPlanTermCapitalized}} adherence metrics",
  PrescriptionsNotOrdered: "Not ordered",
  PrescriptionsNotOrderedDescription:
    "This number is the % of {{patientTermPlural}} who have not placed an order on a {{treatmentPlanTerm}} over the last {{dateRange}} days.",
  PrescriptionState: "Plan state",
  RemindPatientsDescription:
    "See which of your {{patientTermPlural}} might have missed a refill. You can see {{patientTermPlural}} that are likely running out of their products based on your dosage instructions. It's easy to send them a reminder to reorder — right from within the dashboard.",
  RemindPatientsTitle: "Remind {{patientTermPlural}} to refill",
  RemovePatientFilter: "Remove {{patientTerm}} filter",
  ScheduleFeedbackForms:
    "Schedule feedback surveys to follow up with {{patientTermPlural}} who might need help getting started. Surveys are sent 7 days after a {{treatmentPlanTerm}} has been sent if your {{patientTerm}} has not filled their {{treatmentPlanTerm}}.",
  SecondThingToKnow:
    'The number next to "order" is how many times a {{patientTerm}} has purchased from a plan.',
  SeeAdherenceDescription:
    "{{treatmentPlanTermCapitalized}} adherence insights from Fullscript allows you to track your {{patientTermPlural}}' progress by understanding their engagement with your {{treatmentPlanTermPlural}}. This makes it easy to reach out to them, or have more informed discussions about their adherence during appointments.",
  SeeAdherenceHeader: "See your overall adherence performance",
  SeeDispensaryInsights: "See my dispensary insights",
  SeeOrdersDescription:
    "Click to see which {{patientTermPlural}} haven't placed an order yet, and get data from as far back as a month for the {{treatmentPlanTermPlural}} you've written.",
  SeeOrdersTitle: "Drill down into orders",
  SentTo: "Sent to ",
  ShowCanceled: "Show canceled",
  ShowFeedback: "Show feedback",
  Status: "Status",
  TellMeMore: "Tell me more",
  ToBeSent: "To be sent: ",
  TotalActivePrescriptions: "Total active {{treatmentPlanTerm}} ",
  TreatmentAdherenceInsights: "{{treatmentPlanTermCapitalized}} adherence insights",
  TreatmentPlanIsActive: "{{treatmentPlanTerm}} is active.",
  TreatmentPlanIsCanceled: "{{treatmentPlanTerm}} is canceled.",
  TurnOnScheduling: "Turn on adherence survey scheduling",
  TurnOffScheduling: "Turn off adherence survey scheduling",
  UnactivatedPatientDescription:
    "This number is the % of {{patientTermPlural}} who you have written a {{treatmentPlanTerm}} for but have never signed into their accounts over the last {{dateRange}} days.",
  UnactivatedPatientTerm: "Unactivated {{patientTermPlural}}",
  UnderstandPatientBehaviorDescription:
    "You'll be able to see which {{patientTermPlural}} haven't created their accounts yet. Maybe they need help, or simply forgot! You can easily send them a follow-up right from the dashboard to remind them to sign in and order.",
  UnderstandPatientBehaviorHeader: "Get a better understanding of {{patientTerm}} behavior",
  WeAddCommonAdherencebarriers:
    "We have added common adherence barriers experienced by {{patientTermPlural}} to make it easier and quicker to get feedback.",
  WhatDoesFormAsk: "What does the survey ask?",
  YouHaveAdherenceSchedulingOn:
    "Note: you have adherence survey scheduling turned on.<1>Learn more.</1>",
  AdherenceSchedulingIsOn: "Adherence survey scheduling is on. <1>Manage preferences</1>",

  // EmailResponses
  PRICE_OLD: "{{treatmentPlanTermCapitalized}} is out of my budget.",
  PRICE: "Plan is out of my budget.",
  OVERWHELMED_OLD: "I'm feeling overwhelmed by the {{treatmentPlanTerm}}.",
  OVERWHELMED: "I'm feeling overwhelmed by the plan.",
  ELSEWHERE: "I found these products elsewhere.",
  PLANNING: "I am planning to order but have not yet.",
  NOT_PLANNING: "I do not plan to order these products.",
} as const;

export { storeInsights };
